import { mutator } from 'satcheljs';
import { onFluidFileCreated, onFluidFileCreationFailed } from 'owa-fluid-link';
import { getFluidLink } from '../selectors/getFluidLink';

mutator(onFluidFileCreated, actionMessage => {
    const link = getFluidLink(actionMessage.containerId);
    if (link) {
        link.isRetrivingLink = false;
    }
});

mutator(onFluidFileCreationFailed, actionMessage => {
    const link = getFluidLink(actionMessage.containerId);
    if (link) {
        link.isRetrivingLink = false;
    }
});
